import { createRoot } from "react-dom/client";

import { installPlayer } from "@edclub/appmanager-client/legacy-install";

import App from "./App";

installPlayer().then(() => {
  window.approuter.registerStart(() => {
    approuter.header.set({
      style: "headless",
    });
    createRoot(document.getElementById("root")).render(<App />);
  });

  window.approuter.establishEventManagerChannel();
});
